export default "__VITE_ASSET__9a00fce9__"